import React, { useEffect, useState } from 'react';


import { IButtonStyles, IconButton, ITextStyles, ITooltipHostStyles, Text, TooltipHost } from '@fluentui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useId } from '@fluentui/react-hooks';
import { Visibility_Type } from '../../../shared/enums';


const textStyles: Partial<ITextStyles> = {
    root: {
        color: 'inherit'
    }
}

const buttonStyles: Partial<IButtonStyles> = {
    root: {
        width: 25,
        height: 25
    }
}

const calloutProps = { gapSpace: 0 };
// The TooltipHost root uses display: inline by default.
// If that's causing sizing issues or tooltip positioning issues, try overriding to inline-block.
const hostStyles: Partial<ITooltipHostStyles> = { root: { display: 'inline-block' } };


export interface VisibilitaNodeTemplateProps {
    readOnlyMode?: boolean
    uorNode,
    visibilitaItem,
    onVisibilitaChangedHandler: (tipologia: Visibility_Type) => void

}


const VisibilitaNodeTemplate: React.FunctionComponent<VisibilitaNodeTemplateProps> = (props) => {

    const tooltipId = useId('tooltip');

    const [isHovering, setIsHovering] = useState(false);
    const [actionsCssClass, setActionsCssClass] = useState<string>('');

    const handleMouseHover = (ishovering) => {

        setIsHovering(ishovering);
    }

    let labelCssClass = 'visibilita-label';
    if (props.visibilitaItem)
        labelCssClass += ' bolder';

    useEffect(() => {
        let cssClass = 'visibilita-actions';
        if (props.visibilitaItem?.tipologia === Visibility_Type.Proprietario)
            cssClass += ' proprietario';
        else if (props.visibilitaItem?.tipologia === Visibility_Type.Visibilita)
            cssClass += ' visibilita';
        else if (props.visibilitaItem)
            cssClass += ' show';

        setActionsCssClass(cssClass);

    }, [props.visibilitaItem]);

    useEffect(() => {
        if (!props.readOnlyMode) {
            let cssClass = 'visibilita-actions';
            if (isHovering) {
                if (props.visibilitaItem?.tipologia === Visibility_Type.Proprietario)
                    cssClass += ' proprietario';
                else if (props.visibilitaItem?.tipologia === Visibility_Type.Visibilita)
                    cssClass += ' visibilita show';
                else
                    cssClass += ' show';
            }
            else {
                if (props.visibilitaItem?.tipologia === Visibility_Type.Proprietario)
                    cssClass += ' proprietario';
                else if (props.visibilitaItem?.tipologia === Visibility_Type.Visibilita)
                    cssClass += ' visibilita';
                else if (props.visibilitaItem)
                    cssClass += ' show';
            }

            setActionsCssClass(cssClass);
        }
    }, [isHovering]);

    const onVisibilitaChangedHandler = (visibilitaTpye: Visibility_Type) => {
        if (!props.readOnlyMode)
            props.onVisibilitaChangedHandler(visibilitaTpye)

    }
    return (
        <div
            className='visibilita-node-template flex align-items-center'
            onMouseEnter={() => handleMouseHover(true)}
            onMouseLeave={() => handleMouseHover(false)}
        >
            {
                props.visibilitaItem && props.visibilitaItem.tipologia === Visibility_Type.Visibilita &&
                <FontAwesomeIcon className="visibilita-icon" icon={{ prefix: 'far', iconName: 'eye' }} size="2x" />
            }

            {
                props.visibilitaItem && props.visibilitaItem.tipologia === Visibility_Type.Proprietario &&
                <FontAwesomeIcon className="visibilita-icon" icon={{ prefix: 'fas', iconName: 'user-tie' }} size="2x" />
            }

            {/*<FontAwesomeIcon className="error-icon" icon={{ prefix: 'fal', iconName: 'closed-captioning' }} size="2x" />*/}

            <Text className={labelCssClass} styles={textStyles}> {props.uorNode.label}</Text>

            <div style={{ flex: '0 0 64px' }} >
                <div className={actionsCssClass}>
                    <TooltipHost
                        content="Inoltro"
                        // This id is used on the tooltip itself, not the host
                        // (so an element with this id only exists when the tooltip is shown)
                        id={tooltipId}
                        calloutProps={calloutProps}
                        styles={hostStyles}
                    >

                        <IconButton
                            iconProps={{ iconName: 'FastForward' }}
                            title="Inoltro"
                            ariaLabel="Inoltro"
                            checked={props.visibilitaItem && props.visibilitaItem.tipologia === Visibility_Type.Inoltro}
                            onClick={() => onVisibilitaChangedHandler(Visibility_Type.Inoltro)}
                            styles={buttonStyles}
                        />

                    </TooltipHost>
                    <TooltipHost
                        content="Copia conoscenza"
                        // This id is used on the tooltip itself, not the host
                        // (so an element with this id only exists when the tooltip is shown)
                        id={tooltipId}
                        calloutProps={calloutProps}
                        styles={hostStyles}
                    >
                        <IconButton
                            iconProps={{ iconName: 'Accounts' }}
                            title="Copia conoscenza"
                            ariaLabel="Copia conoscenza"
                            checked={props.visibilitaItem && props.visibilitaItem.tipologia === Visibility_Type.CopiaConoscenza}
                            onClick={() => onVisibilitaChangedHandler(Visibility_Type.CopiaConoscenza)}
                            styles={buttonStyles}
                        />


                    </TooltipHost>
                </div>
            </div>
        </div>
    )

}

export default VisibilitaNodeTemplate;






